import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextHelperService {

  constructor() { }

  pronounSwaps = {
    self: {
      "subjective": "you",
      "objective": "you",
      "possessive": "your",
      "Subjective": "You",
      "Possessive": "Your",
      "neutral": "your",
      "Informal": "You'll",
      "informal": "you'll",
      "pluralize": ""
    },
    selfWithProCopy: {
      "subjective": "they",
      "objective": "your client",
      "possessive": "their",
      "Subjective": "They",
      "Possessive": "Their",
      "neutral": "the",
      "Informal": "They'll",
      "informal": "they'll",
      "pluralize": "s"
    },
    pro: {
      "subjective": "they",
      "objective": "them",
      "possessive": "their",
      "Subjective": "They",
      "Possessive": "Their",
      "neutral": "the",
      "Informal": "They'll",
      "informal": "they'll",
      "pluralize": "s"
    }
  }

  swapPronouns = (input:string, path:string) => {
    return (input && path) ? input.replace( /{{([a-zA-Z']+)}}/gm, ( fullMatch, substring ) => {
      return this.pronounSwaps[path][substring];
    } ) : "";
  }
}
